
<!-- 
MergeVisitModal.vue
功能：合併拜訪記錄視窗
作者：i9400538 陳博承
完成：2021-12-13
-->
<template>
  <div class="modal fade" :class="{ 'is-open': open }">
    <div class="modal-dialog">
      <div class="modal-content" :class="{'section-loading': isLoading}">
        <div class="modal-header">
          <a class="close" @click="$emit('close')">
            <i class="icon-close"></i>
          </a>
          <h3 class="modal-title">合併拜訪記錄</h3>
        </div>
        <!-- 文字顯示區塊 -->
        <div>
          <h6 class="padding-left-5">本客戶尚未輸入ID(身分證字號)，若要將本客戶拜訪紀錄合併至指定有ID客戶下，請於下方輸入該客戶ID。</h6>
          <h6 class="padding-left-5 text-red">
            ※請注意：
            <br />1. 拜訪紀錄資料一旦與有ID之客戶檔案合併，將無法還原，請再三確認要合併的客戶是否正確
            <br />2. 本畫面僅合併「拜訪紀錄」，不包含其餘客戶資料，若欲合併所有客戶資料，請以簡覆表聯繫數位支援科
          </h6>
          <!-- 輸入區塊 -->
          <div>
            <h6 class="padding-left-5">請輸入想合併之客戶ID</h6>
            <div class="col-3 padding-left-5">
              <form class="form search-container">
                <div class="form-group">
                  <input
                    type="text"
                    v-model="keyword"
                    class="form-control"
                    placeholder="輸入客戶ID"
                    maxlength="10"
                    @keydown.enter="search"
                  />
                  <button
                    type="button"
                    @click.prevent="search"
                    class="btn btn-text m-0 btn-icon-use"
                  >
                    <i class="icon-search"></i>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        <!-- 資料區塊 -->
        <label v-if="custData.id" class="padding-left-5 font-use">請確認是否為下列客戶 :</label>
        <div v-if="custData.id" class="padding-bottom-5 padding-left-2">
          <section>
            <table
              id="custData_datatable"
              class="table datatable table-striped area-list-datatable w-98"
            >
              <thead>
                <tr>
                  <th id="col_name">姓名</th>
                  <th id="col_id">ID</th>
                  <th id="col_mobile">手機</th>
                  <th id="col_birthday">生日</th>
                  <th id="col_address" ref="lastCol">地址</th>
                </tr>
              </thead>
              <tbody id="tbody-custData">
                <tr>
                  <td>
                    <Tooltip
                      position="top"
                      :id="custData.id"
                      :name="custData.name"
                      :birthday="custData.birthday"
                      :mobile="custData.mobile"
                      :address="custData.address"
                    >{{custData.name | getMaskName}}</Tooltip>
                  </td>
                  <td>{{custData.id | getMaskID}}</td>
                  <td>{{custData.mobile | getMaskMobile}}</td>
                  <td>
                    {{custData.birthday | dateFormat | getMaskBirthday}}
                    <br />
                    ({{custData.age ? custData.age : "— —"}}歲)
                  </td>
                  <td>{{custData.address | getMaskAddress}}</td>
                </tr>
              </tbody>
            </table>
          </section>
        </div>
        <!-- 按鈕區塊 -->
        <div class="action text-right padding-right-5">
          <button type="button" @click.stop.prevent="$emit('close')" class="btn btn-default">取消</button>
          <button
            type="button"
            @click.stop.prevent="submit"
            :disabled="!custData.id"
            class="btn btn-primary"
          >確認</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { commonMixin } from "@/mixins/common";
//component
import Tooltip from "@/desktop/components/ToolTip";
//service
import { getCustInfo, mergeVisit } from "@/service";
export default {
  name: "MergeVisitModal",
  mixins: [commonMixin],
  components: { Tooltip },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    csid: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      custData: {},
      keyword: "",
      isLoading: false
    };
  },
  watch: {
    open: function() {
      this.init();
    }
  },
  methods: {
    //初始化
    init() {
      this.custData = {};
      this.isLoading = false;
      this.keyword = "";
    },
    //查詢
    search() {
      if (!this.keyword.trim()) {
        return;
      }
      this.isLoading = true;
      getCustInfo(
        this.$store.state.userInfo.id,
        this.$store.state.userInfo.id,
        this.keyword
      ).then(result => {
        this.isLoading = false;
        if (
          result.header &&
          result.header.status === "200" &&
          result.body &&
          result.body.customer
        ) {
          let data = result.body.customer;
          let msg = "查無資料";
          if (data.id) {
            msg = "查詢成功";
            this.custData = data;
            this.custData.address =
              (data.home_addr_zip || "") +
              (data.home_addr1 || "") +
              (data.home_addr2 || "") +
              (data.home_addr3 || "");
            this.custData.age =
              data.age == undefined ? "" : data.age.toString(); //客戶年齡
            this.registerHanlink(); // for hard word
          } else {
            this.custData = {};
          }
          this.setToastMsg(msg);
        } else {
          this.custData = {};
          this.setToastMsg(result.header.message);
        }
      });
    },
    //確認
    submit() {
      this.isLoading = true;
      mergeVisit(
        this.$store.state.userInfo.id,
        this.csid,
        this.custData.id,
        this.custData.name
      ).then(result => {
        this.isLoading = false;
        if (
          result.header &&
          result.header.status === "200" &&
          result.body.result
        ) {
          this.$emit(
            "submit",
            "此客戶拜訪記錄已與ID : " + this.custData.id + " 合併成功"
          );
        } else {
          this.$emit("submit", "合併拜訪記錄失敗，請洽數位支援科(MXC3_1020)");
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.w-98 {
  width: 98%;
}
.btn-icon-use {
  position: absolute;
  right: 0;
  top: 0;
}
.input-txt {
  border: 1px solid #c2c4c7;
  border-radius: 4px;
}
.padding-top-5 {
  padding-top: 5%;
}
.padding-bottom-5 {
  padding-bottom: 5%;
}
.padding-left-2 {
  padding-left: 2%;
}
.padding-left-5 {
  padding-left: 5%;
}
.padding-right-5 {
  padding-right: 5%;
}
.font-use {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 0.5rem;
  line-height: 1.2;
}
.table.datatable {
  tbody {
    tr > td {
      &:first-child {
        padding-top: 10px;
      }
    }
  }
}
</style>